<ng-template>
	<div
		(click)="closed.emit()"
		class="max-h-100 overflow-y-scroll rounded-md text-left bg-surface-container-high z-1000 px-4 py-2"
	>
		<ng-content></ng-content>
	</div>
</ng-template>
